module.exports = __webpack_public_path__ + "static/img/3.f52f855.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/3.png
// module id = lrQm
// module chunks = 1